import { useEffect, useState } from "react";
import { useUser } from "../../auth/UserContext.js";
import { patchSettings } from "../../api/settings.js";
import type { ParentBundle } from "../../api/me.js";

export default function Settings() {
  const { bundle, refresh } = useUser();
  const [bp, setBp] = useState<number>(0);
  const [savingRate, setSavingRate] = useState(false);

  useEffect(() => {
    if (bundle && bundle.user.role === "parent") {
      setBp((bundle as ParentBundle).settings.interestRateAnnualBasisPoints);
    }
  }, [bundle]);

  if (!bundle || bundle.user.role !== "parent") return null;

  const ratePct = bp / 100;

  const commitRate = async (next: number) => {
    setBp(next);
    setSavingRate(true);
    try {
      await patchSettings({ interestRateAnnualBasisPoints: next });
      await refresh();
    } finally {
      setSavingRate(false);
    }
  };

  return (
    <div>
      <h1 style={{ marginBottom: 6 }}>Settings</h1>
      <p className="soft" style={{ marginBottom: 28 }}>
        Set the bank interest rate. Kid allowances auto-update from their age.
      </p>

      <div className="card" style={{ marginBottom: 20 }}>
        <div className="row-between" style={{ marginBottom: 14 }}>
          <div>
            <h3>Bank interest rate</h3>
            <div className="soft" style={{ fontSize: 13, marginTop: 4 }}>
              Paid monthly on each kid&apos;s balance.
            </div>
          </div>
          <div className="money money-lg" style={{ color: "var(--brand)" }}>
            {ratePct.toFixed(1)}%
          </div>
        </div>
        <input
          type="range"
          min={0}
          max={1200}
          step={10}
          value={bp}
          onChange={(e) => setBp(Number(e.target.value))}
          onMouseUp={(e) => void commitRate(Number((e.target as HTMLInputElement).value))}
          onTouchEnd={(e) => void commitRate(Number((e.target as HTMLInputElement).value))}
          onKeyUp={(e) => void commitRate(Number((e.target as HTMLInputElement).value))}
          disabled={savingRate}
          style={{ width: "100%", accentColor: "var(--brand)" }}
        />
        <div className="row-between soft" style={{ fontSize: 12, marginTop: 4 }}>
          <div>0%</div>
          <div>12%</div>
        </div>
      </div>
    </div>
  );
}
